import React, {useRef} from 'react';
import html2canvas from 'html2canvas';

const usePageCapture = () => {
  const captureRef = useRef(null);

  const capturePage = async () => {
    if (captureRef.current) {
      const elementToCapture = captureRef.current;

      const canvas = await html2canvas(elementToCapture, {useCORS: true});
      const dataUrl = canvas.toDataURL('image/jpeg');

      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = 'OrderSummary.jpg';
      a.click();
    }
  };

  return {captureRef, capturePage};
};

export default usePageCapture;
